// 梁
import store from "@/store/index";
import rlModelData from "@/rlMxModules/rlDataClass/rlModelData";
import { getEntityData } from "@/rlMxModules/operate/operateApi";
import { getPKPM_SlabHoleData } from "@/rlMxModules/Opencascad/getModelDrawData";
import { calculatePointProjectionOnPlane } from "@/rlMxModules/operate/GraphicDataCal";
class rlSlabHoleData extends rlModelData {
  getModel3dData = store.state.globalData.rl_wasm_module.getModel3dData;
  // wasm接口方法
  // getPKPM_SlabHoleData =
  // store.state.globalData.rl_wasm_module.getPKPM_SlabHoleData;
  constructor() {
    super();
    this.componentType = "SlabHole";
    // 顶点数据
    this.points = [];
    this.deviation = 0;
    this.m_JointData = {}; //板洞所在的节点
    this.m_SlabData = {}; //板洞所在的板
    this.EccX = 0;
    this.EccY = 0;
    this.Rotation = 0;

    this.slabThickness = 0; //板洞所在的楼板厚度

    this.classTypeName = "rlSlabHole"; // 梁类型
    this._threeObj = null; //三维图形对象
    this.isSelect = false; //自定义是否选中标识
    this.Color = null;
    this.ModelType = "板洞";
    this.m_groupName = "rlSlabHoleGroup"; //组名
    this.isWasmGeted = false; //是否已经获取wasm数据
  }

  initData(obj) {
    super.initData(obj);
    this.m_JointData = obj.m_JointData;
    this.m_SlabData = obj.m_SlabData;
    this.EccX = obj.EccX;
    this.EccY = obj.EccY;
    this.Rotation = obj.Rotation;
    this.Color = obj.Color;

    this.index2dData = obj.index2dData;
    this.index3dData = obj.index3dData;
    this.points = obj.points;
    this.slabThickness = obj.slabThickness;
    this.m_JointData.m_slabHoleId = this.Guid;
  }

  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_JointData = getEntityData({
      Guid: obj.m_JointData,
      classTypeName: "rlJoint",
    }); // rlAppObj.rlMxDrawObject.getMxEntity(obj.m_JointData);
    this.m_SlabData = getEntityData({
      Guid: obj.m_SlabData,
      classTypeName: "rlSlab",
    });
    this.EccX = obj.EccX;
    this.EccY = obj.EccY;
    this.Rotation = obj.Rotation;
    this.m_SlabData.m_holeArray.push(this.Guid);
    this.slabThickness = obj.slabThickness;
  }

  // 数据转换
  convert() {
    if (!this.isWasmGeted || (!this.index2dData && !this.index3dData)) {
      let res = getPKPM_SlabHoleData(
        this.m_sectParamData.Kind,
        this.m_sectParamData.ShapeVal,
        this.m_JointData.m_pt[0],
        this.m_JointData.m_pt[1],
        this.LevelB,
        this.Height,
        this.EccX,
        this.EccY,
        this.Rotation,
        this.slabThickness
      );

      if (!res) return;
      //

      this.getModelDrawData(JSON.parse(res));
      this.handleSlabHole3dPoints();

      // let wasmData = JSON.parse(res);
      // let data = `{"${this.Guid}":${JSON.stringify(wasmData)}}`;
      // let data3D = this.getModel3dData(data);
      // if (!data3D) return;

      // data3D = JSON.parse(data3D)["3D"][this.Guid];
      // this.points = data3D.Points;
      // this.index3dData = {
      //   points: data3D.Points,
      //   faces: data3D["3dFaces"].map((item) => item.index).flat(),
      // };
    } else {
      if (!Array.isArray(this.index2dData)) {
        // 如果不是数组，则将字符串转换为数组并将元素转换为数字
        this.index2dData = this.index2dData.split(",").map(Number);
      }
    }
    if (this.m_sectParamData.ShapeVal) {
      let splitdata = this.m_sectParamData.ShapeVal.split(",");
      let sectString = splitdata.splice(1, splitdata.length - 3);
      sectString = sectString.join("*");
      this.m_sectGroupName = sectString;
      this.CurrtSect = sectString + "*" + this.slabThickness;
    }
  }

  //处理楼板是斜面时板洞的三维显示
  handleSlabHole3dPoints() {
    //将板洞的三维顶点投影到楼板的三维平面上
    if (this.m_SlabData) {
      let slab3dPointsTmp = []; //3d平面上的顶点
      for (let i = 0; i < this.m_SlabData.index3dData.points.length; i += 3) {
        slab3dPointsTmp.push(
          new THREE.Vector3(
            this.m_SlabData.index3dData.points[i],
            this.m_SlabData.index3dData.points[i + 1],
            this.m_SlabData.index3dData.points[i + 2]
          )
        );
      }
      let slab2dPoints = []; //2d平面上的顶点
      for (let i = 0; i < this.m_SlabData.index2dData.length; i += 3) {
        slab2dPoints.push(
          new THREE.Vector3(
            this.m_SlabData.index2dData[i],
            this.m_SlabData.index2dData[i + 1],
            0
          )
        );
      }

      let slab3dPoints = []; //楼板顶面上的顶点集合
      for (let i = 0; i < slab2dPoints.length; i++) {
        let pt3ds = slab3dPointsTmp.filter(
          (item) => item.x == slab2dPoints[i].x && item.y == slab2dPoints[i].y
        );
        if (pt3ds.length > 0) {
          //取Z值较小的点
          let minZ = pt3ds.reduce((min, item) => {
            return Math.min(min, item.z);
          }, Infinity);
          slab3dPoints.push(
            new THREE.Vector3(slab2dPoints[i].x, slab2dPoints[i].y, minZ)
          );
        }
      }

      let slabHole3dPoints = []; //板洞的三维顶点
      for (let i = 0; i < this.index3dData.points.length; i += 3) {
        slabHole3dPoints.push(
          new THREE.Vector3(
            this.index3dData.points[i],
            this.index3dData.points[i + 1],
            this.index3dData.points[i + 2]
          )
        );
      }

      //将板洞的三维顶点投影到楼板的三维平面上
      let pointsTmp = [];
      for (let i = 0; i < slabHole3dPoints.length; i++) {
        let point = slabHole3dPoints[i];
        let projection = calculatePointProjectionOnPlane(point, slab3dPoints);
        if (point.z == this.LevelB + this.Height) {
          projection.z += this.slabThickness;
        }
        pointsTmp.push(projection);
      }
      let points = [];
      for (let i = 0; i < pointsTmp.length; i++) {
        points.push(pointsTmp[i].x, pointsTmp[i].y, pointsTmp[i].z);
      }

      this.index3dData.points = points;
    }
  }

  // wasm截面数据转换
  // getModelDrawData(modelData) {
  //   // this.index3dData = modelData["3D"]["3dFaces"]
  //   //   .map((item) => item.index)
  //   //   .flat();
  //   this.index2dData = modelData["2DUpView"];
  //   this.SectData = modelData["SectData"];
  //   this.OtherData = JSON.stringify(modelData);
  // }

  // 克隆方法
  myClone() {
    let newObj = new rlSlabHoleData();
    super.cloneData(newObj);
    newObj.m_JointData = this.m_JointData;
    newObj.m_SlabData = this.m_SlabData;
    newObj.EccX = this.EccX;
    newObj.EccY = this.EccY;
    newObj.Rotation = this.Rotation;
    newObj.Color = this.Color;
    newObj.points = this.points;
    return newObj;
  }

  // 绘制
  draw() {
    super.draw();
    if (this.m_SlabData && !this.m_SlabData.m_holeArray.includes(this.Guid)) {
      this.m_SlabData.m_holeArray.push(this.Guid);
    }
    this.m_JointData.m_slabHoleId = this.Guid;
    if (this.m_sectParamData.ShapeVal) {
      let splitdata = this.m_sectParamData.ShapeVal.split(",");
      let sectString = splitdata.splice(1, splitdata.length - 3);
      sectString = sectString.join("*");
      // this.m_sectGroupName = sectString;
      this.CurrtSect = sectString;
    }
  }

  // 返回图形源数据
  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;

    if (this.m_JointData) data["JtGuid"] = this.m_JointData.Guid;
    if (this.m_SlabData) data["SlabGuid"] = this.m_SlabData.Guid;
    data["Drawing_2D"] = this.index2dData ? this.index2dData.join(",") : null;
    data["Drawing_3D"] = this.index3dData
      ? JSON.stringify(this.index3dData)
      : null;
    // data["Height"] = this.Height;
    data["EccX"] = this.EccX;
    data["EccY"] = this.EccY;
    data["Rotation"] = this.Rotation;
    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();

    data["m_JointData"] = this.m_JointData.Guid;
    data["m_SlabData"] = this.m_SlabData.Guid;
    data["EccX"] = this.EccX;
    data["EccY"] = this.EccY;
    data["Rotation"] = this.Rotation;
    data["slabThickness"] = this.slabThickness;

    return data;
  }

  // 删除
  erase() {
    this.m_JointData ? (this.m_JointData.m_slabHoleId = null) : "";
    this.m_SlabData.m_holeArray = this.m_SlabData.m_holeArray.filter(
      (item) => item != this.Guid
    );
    super.erase();
  }
}

export { rlSlabHoleData };
